export default "__VITE_ASSET__ba03b958__"